module.exports = __webpack_public_path__ + "img/walkman.2018b259.png";